import { render, staticRenderFns } from "./SolicitacaoParceiria.vue?vue&type=template&id=6827d6a2&"
import script from "./SolicitacaoParceiria.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoParceiria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports